<sc-flex vertical fitHeight stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label
    dictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.dialog-select-gate-title-name-label"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-tab-group noContent (tabChanged)="handleTabChange($event)" >
    <sc-tab titleDictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.entrance-tab" data="IN"></sc-tab>
    <sc-tab titleDictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.leave-tab" data="OUT"></sc-tab>
  </sc-tab-group>


  <sc-flex-fitting-content vertical>
    <sc-no-data-container [hasData]="areaGates?.length > 0" fitHeight>
      <sc-scroll-pane>
        <sc-padding>
          <sc-flex vertical stretchContent [gap]="16">
            @for (areaGate of areaGates; track areaGate) {
              <sc-selectable-tile (click)="selectAreaGate(areaGate)"
                [style]="areaGate === selectedAreaGate ? 'selected' : 'default'">
                <app-gate-keeper-control-select-gate-tile [areaGate]="areaGate" ></app-gate-keeper-control-select-gate-tile>
              </sc-selectable-tile>
            }
          </sc-flex>
        </sc-padding>
      </sc-scroll-pane>
    </sc-no-data-container>
  </sc-flex-fitting-content>

  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="close()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary (click)="confirm()" [disabled]="selectedAreaGate == null"></sc-confirm-button>
    </sc-flex>
  </sc-padding>

</sc-flex>
